import React, { createContext } from "react";
import useParticipant           from "~/hooks/useParticipant";

const ParticipantContext = createContext({});

export function ParticipantProvider({ value, children }) {
  const {
    participant,
    customer,
    getCustomer,
    getParticipant,
    loading,
    loadingCustomer,
  } = useParticipant(value);

  return (
    <ParticipantContext.Provider
      value={{
        loading,
        loadingCustomer,
        participant,
        customer,
        getCustomer,
        getParticipant,
      }}
    >
      {children}
    </ParticipantContext.Provider>
  );
}

export default ParticipantContext;
